import { render, staticRenderFns } from "./select-campaign-type.vue?vue&type=template&id=2a7826a4&scoped=true"
import script from "./select-campaign-type.vue?vue&type=script&lang=js"
export * from "./select-campaign-type.vue?vue&type=script&lang=js"
import style0 from "./select-campaign-type.vue?vue&type=style&index=0&id=2a7826a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7826a4",
  null
  
)

export default component.exports